__turbopack_context__.v({
  "content": "AiInRecruitingCtaSection-module__MI8zJq__content",
  "ctaSection": "AiInRecruitingCtaSection-module__MI8zJq__ctaSection",
  "subtitle": "AiInRecruitingCtaSection-module__MI8zJq__subtitle",
  "title": "AiInRecruitingCtaSection-module__MI8zJq__title",
});
